import React from 'react'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { StylingProvider, createRenderer } from '@ynap/fela'
import { AddressValidationProvider } from '@ynap/address-form-v1'
import { App } from 'app/containers'
import themes from '../themes'

export default (store, history, messages, config, optimizely) => {
    const stateConfig = store.getState().config
    const {locale, addressValidationConfig} = store.getState()
    const {countries, countryList} = addressValidationConfig || {}
    const brand =  locale.language === 'ar' ? stateConfig.head.business.toLowerCase()+"Rtl" : stateConfig.head.business.toLowerCase()

    const renderer = createRenderer({ brand, custom: themes[brand] })

    return (
        <Provider store={store}>
                <AddressValidationProvider  countries={countries} countryList={countryList}>
                    <ConnectedRouter history={history}>
                        <StylingProvider renderer={renderer} brand={brand}>
                            <App messages={messages} config={config} optimizely={optimizely}/>
                        </StylingProvider>
                    </ConnectedRouter>
                </AddressValidationProvider>
        </Provider>
    )
}
